<template>
  <div class="lesson-item">
    <vv-box-slider shadow>
      <div class="step-item-header">
        <span class="title">{{ lessonStep.title }}</span>
        <span class="content-duration">{{ contentDuration }}</span>
      </div>
    </vv-box-slider>
    <div v-swiper:mySwiper="swiperOption">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="lesson in lessons" :key="lesson.id">
          <vv-mobile-tile
          :title="lesson.title"
          :image="lesson.tileImage"
          :secondary="lessonDuration(lesson)"
          :status="lessonStatus(lesson.id)"
          @click="openLesson(lesson.id)"
        />
        </div>
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Hooper, Slide } from 'hooper'

import { VvBoxSlider, VvMobileTile } from '@/components/common'
import userMixin from '@/mixins/user'
import { isLessonComplete } from '@/helpers/userCompletion'
// import VvBoxSlider from '../common/VvBoxSlider.vue'


export default {
  name: 'LessonStepItem',
  components: { VvBoxSlider, VvMobileTile, Hooper, Slide },
  mixins: [userMixin],
  props: {
    themeId: {
      type: String,
      required: true
    },
    lessonId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 2.3,
        spaceBetween: 15,
        freeMode: true,
        grabCursor: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'custom'
        }
      }
    }
  },
  computed: {
    lessonStep() {
      return this.$store.state.lesson.lessonStep.byId[this.lessonId]
    },
    lessons() {
      return this.lessonStep.lessons.map(id => this.$store.state.lesson.lesson.byId[id])
    },
    contentDuration() {
      const duration = this.lessons
        .filter(lesson => Number.isSafeInteger(lesson.duration))
        .reduce((duration, lesson) => duration + lesson.duration, 0)

      return this.$tc('masterclass.notice', duration, { duration })
    }
  },
  methods: {
    getLessonId(lesson) {
      return lesson.id
    },
    lessonDuration(lesson) {
      let duration = 0

      if (lesson && lesson.duration && Number.isSafeInteger(lesson.duration)) {
        duration = lesson.duration
      }

      return this.$tc('masterclass.notice', duration, { duration })
    },
    /**
     * Open the given lesson
     * @param {string} lessonId
     */
    openLesson(lessonId) {
      this.$router.push({
        name: 'lesson',
        params: {
          themeId: this.themeId,
          lessonStepId: this.lessonId,
          lessonId: lessonId
        }
      })
    },
    lessonStatus(lessonId) {
      return isLessonComplete(lessonId) ? 'finished' : 'unstarted'
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.swiper-wrapper {
  height: 100%;
  width: 100%;
  margin-bottom: 45px;
  

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    font-size: 12;
  }
}

.step-item-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  color: $font-banner;

  .title {
    align-self: center;
    flex-grow: 1;
    width: 50%;
  }

  .content-duration {
    font-size: 11px;
    align-self: center;
    font-weight: normal;
  }
}
</style>
